/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_LoadingInputs */

const vi_einvoice_credential_loading = /** @type {(inputs: Einvoice_Credential_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kiểm tra tài khoản MISA…`)
};

/**

* @param {Einvoice_Credential_LoadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_loading = /** @type {((inputs?: Einvoice_Credential_LoadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_LoadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_loading(inputs)
});